import React from 'react';

// Simple 100% Brasil badge SVG
const BrasilBadge = ({ style, ...props }) => (
  <svg width="60" height="20" viewBox="0 0 60 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={style} {...props}>
    <rect x="0.5" y="0.5" width="59" height="19" rx="9.5" fill="#fff" stroke="#F5C84C" strokeWidth="1.2" />
    <g>
      <circle cx="13" cy="10" r="6" fill="#14B88D" />
      <circle cx="13" cy="10" r="3.5" fill="#F5C84C" />
    </g>
    <text x="34" y="14.5" textAnchor="middle" fontFamily="inherit" fontWeight="bold" fontSize="11" fill="#14B88D">100% Brasil</text>
  </svg>
);

export default BrasilBadge;
